/** Helpers for Workbench data-mode gating on transaction Load / Expand / triage paths. */

import type { WorkbenchDataMode } from './workbenchDataMode';

export function isMockDataMode(dataMode: string | null | undefined): boolean {
    return dataMode === 'mock';
}

export function wantsCacheOnly(dataMode: string | null | undefined): boolean {
    return dataMode === 'cached';
}

/** @deprecated Prefer isMockDataMode — mock gating is no longer demo-scoped. */
export function isMockDemoSession(
    activeDemoId: string | null | undefined,
    dataMode: string | null | undefined,
): boolean {
    return isMockDataMode(dataMode);
}

export const MOCK_DEMO_TX_TOAST =
    'Mock mode — sample transfers are already on the canvas. Switch to Live mode to fetch real blockchain txs.';

export type { WorkbenchDataMode };
